export enum FileInputType {
    DEFAULT,
    NEW_PRODUCT_UPLOAD,
    PRODUCT_BULK_UPLOAD,
    DOCUMENT_UPLOAD,
}
